var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 144,
    viewBox: "0 0 227 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2122_12420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.257 128.652L197.236 117.476L186.831 128.652H166.405H122.471V76.6247H102.045L127.481 18.4309H152.146L161.01 38.4712V18.4309H191.841L197.236 33.4611L202.632 18.4309H226.141V9.56698C226.141 4.17153 221.901 -0.067749 216.506 -0.067749H9.93745C4.54201 -0.067749 0.302734 4.17153 0.302734 9.56698V134.818C0.302734 140.214 4.54201 144.453 9.93745 144.453H216.506C221.901 144.453 226.141 140.214 226.141 134.818V128.652H207.257Z",
    fill: "#0071CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.954 122.486H226.141L204.944 99.7479L226.141 77.3954H210.34L196.851 92.0401L183.748 77.3954H167.562L189.143 100.133L167.562 122.486H183.362L196.851 107.841L209.954 122.486Z",
    fill: "#0071CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.74 112.08V105.143H167.176V94.7379H141.74V87.8009H167.561V77.3954H129.408V122.486H167.561V112.08H141.74Z",
    fill: "#0071CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.194 70.8438H225.755V25.3679L207.257 25.7533L197.236 53.8867L186.831 25.7533H167.562V70.8438H179.894V39.2419L191.456 70.8438H202.246L214.194 39.2419V70.8438Z",
    fill: "#0071CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.907 25.7533H132.106L112.065 70.8438H125.554L129.408 61.9799H150.219L154.073 70.8438H167.947L147.907 25.7533ZM133.647 51.5744L139.813 36.9296L145.98 51.5744H133.647Z",
    fill: "#0071CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.964 98.5917L226.141 110.924V86.2593L214.964 98.5917Z",
    fill: "#0071CE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2122_12420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 226.025,
    height: 144,
    fill: "white",
    transform: "translate(0.208984)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/Amex.a39e3f1cb84d7f741ad616b3ea557d98.svg";
export { ForwardRef as ReactComponent };